import { formatAssetUrl } from '@opallabs/kuiper'
import { isBefore } from '../../../helpers/dateHelpers'
import { isApproval } from '../../../helpers/matchers'

const retinaScaleFactor = 3

export const getValidPeople = (item, people) => {
  if (item.id && isApproval(item.type)) {
    const assigneeId = item.id.split('-')[1]
    return people.filter(
      (person) =>
        parseInt(person.id, 10) !== parseInt(assigneeId, 10) &&
        item.role_system_name !== 'view_only'
    )
  }
  return people
}

export const resizeAsset = (url) =>
  formatAssetUrl(url, { width: 20 * retinaScaleFactor })

export const personAvatarUrl = (person) => {
  if (!person.avatar) return null
  const avatarUrl = person.avatar.full_url || person.avatar.url
  return resizeAsset(avatarUrl)
}

export const modifiedPeople = (people) => {
  if (!people) {
    return []
  }

  return people.map((person) =>
    Object.assign(person, {
      imageUrl: personAvatarUrl(person),
    })
  )
}

export const itemSorter = () => (a, b) => {
  if (!a.created_at) {
    if (!b.created_at) {
      return 0
    }
    return 1
  }

  if (!b.created_at) {
    return -1
  }

  if (isBefore(a.created_at, b.created_at)) {
    return -1
  }

  if (isBefore(b.created_at, a.created_at)) {
    return 1
  }

  return 0
}
